/**
 * @generated SignedSource<<4cc29f63f3e08e345625393eceb06768>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type customThemeProviderQueryCustomStyleQuery$variables = Record<PropertyKey, never>;
export type customThemeProviderQueryCustomStyleQuery$data = {
  readonly marketplaceCustomStyleForSeller: {
    readonly customStyle: {
      readonly backofficeCustomTheme: {
        readonly app: {
          readonly backgroundColor: string | null;
          readonly backgroundColorBase: string | null;
          readonly backgroundColor_dark: string | null;
          readonly backgroundToolbar: string | null;
          readonly component: {
            readonly accordion: {
              readonly lineColor: string | null;
              readonly textItemColor: string | null;
              readonly titleColor: string | null;
            } | null;
            readonly button: {
              readonly basic: {
                readonly active: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
                readonly border: string | null;
                readonly default: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
                readonly disabled: {
                  readonly backgroundColor: string | null;
                  readonly border: string | null;
                  readonly opacity: number | null;
                  readonly textColor: string | null;
                } | null;
                readonly hover: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
              } | null;
              readonly borderRadius: string | null;
              readonly destructive: {
                readonly active: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
                readonly border: string | null;
                readonly default: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
                readonly disabled: {
                  readonly backgroundColor: string | null;
                  readonly border: string | null;
                  readonly opacity: number | null;
                  readonly textColor: string | null;
                } | null;
                readonly hover: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
              } | null;
              readonly disabled: {
                readonly backgroundColor: string | null;
                readonly border: string | null;
                readonly textColor: string | null;
              } | null;
              readonly fontSize: string | null;
              readonly fontWeight: number | null;
              readonly primary: {
                readonly active: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
                readonly border: string | null;
                readonly default: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
                readonly disabled: {
                  readonly backgroundColor: string | null;
                  readonly border: string | null;
                  readonly opacity: number | null;
                  readonly textColor: string | null;
                } | null;
                readonly hover: {
                  readonly backgroundColor: string | null;
                  readonly textColor: string | null;
                } | null;
              } | null;
            } | null;
            readonly card: {
              readonly borderRadius: string | null;
              readonly text: {
                readonly color: string | null;
                readonly size: string | null;
                readonly weight: number | null;
              } | null;
              readonly title: {
                readonly color: string | null;
                readonly size: string | null;
                readonly weight: number | null;
              } | null;
            } | null;
            readonly checkbox: {
              readonly borderRadius: string | null;
              readonly height: string | null;
              readonly selected: {
                readonly active: {
                  readonly background: string | null;
                  readonly border: string | null;
                  readonly inputColor: string | null;
                } | null;
                readonly disabled: {
                  readonly background: string | null;
                  readonly border: string | null;
                  readonly inputColor: string | null;
                } | null;
              } | null;
              readonly textSize: string | null;
              readonly textWeight: number | null;
              readonly unselected: {
                readonly active: {
                  readonly background: string | null;
                  readonly border: string | null;
                } | null;
                readonly disabled: {
                  readonly background: string | null;
                  readonly border: string | null;
                } | null;
              } | null;
              readonly width: string | null;
            } | null;
            readonly icon: {
              readonly button: {
                readonly default: {
                  readonly color: string | null;
                  readonly height: string | null;
                  readonly width: string | null;
                } | null;
                readonly hover: {
                  readonly color: string | null;
                  readonly height: string | null;
                  readonly width: string | null;
                } | null;
              } | null;
              readonly help: {
                readonly color: string | null;
                readonly height: string | null;
                readonly width: string | null;
              } | null;
              readonly info: {
                readonly default: {
                  readonly color: string | null;
                  readonly height: string | null;
                  readonly width: string | null;
                } | null;
                readonly hover: {
                  readonly color: string | null;
                  readonly height: string | null;
                  readonly width: string | null;
                } | null;
              } | null;
            } | null;
            readonly link: {
              readonly color: string | null;
              readonly decoration: string | null;
            } | null;
            readonly message: {
              readonly backgroundColor: string | null;
              readonly borderRadius: string | null;
              readonly error: {
                readonly backgroundColor: string | null;
                readonly color: string | null;
              } | null;
              readonly fontSize: string | null;
              readonly fontWeight: number | null;
              readonly padding: string | null;
              readonly warning: {
                readonly backgroundColor: string | null;
                readonly color: string | null;
              } | null;
            } | null;
            readonly pageBlocksContainer: {
              readonly pageBlock: {
                readonly backgroundColor: string | null;
                readonly border: string | null;
                readonly borderRadius: string | null;
                readonly height: string | null;
                readonly padding: string | null;
                readonly pageBlockButton: {
                  readonly fontSize: string | null;
                  readonly padding: string | null;
                } | null;
                readonly pageBlockDescription: {
                  readonly fontSize: string | null;
                } | null;
                readonly pageBlockLearnMore: {
                  readonly color: string | null;
                  readonly fontSize: string | null;
                  readonly fontWeight: number | null;
                } | null;
                readonly pageBlockTitle: {
                  readonly color: string | null;
                  readonly fontSize: string | null;
                  readonly fontWeight: number | null;
                  readonly gap: string | null;
                } | null;
              } | null;
            } | null;
            readonly pageTitle: {
              readonly size: string | null;
              readonly textColor: string | null;
              readonly weight: number | null;
            } | null;
            readonly radio: {
              readonly borderRadius: string | null;
              readonly height: string | null;
              readonly selected: {
                readonly active: {
                  readonly background: string | null;
                  readonly border: string | null;
                  readonly inputColor: string | null;
                } | null;
                readonly disabled: {
                  readonly background: string | null;
                  readonly border: string | null;
                  readonly inputColor: string | null;
                } | null;
              } | null;
              readonly textSize: string | null;
              readonly textWeight: number | null;
              readonly unselected: {
                readonly active: {
                  readonly background: string | null;
                  readonly border: string | null;
                } | null;
                readonly disabled: {
                  readonly background: string | null;
                  readonly border: string | null;
                } | null;
              } | null;
              readonly width: string | null;
            } | null;
            readonly switch: {
              readonly borderRadius: string | null;
              readonly default: {
                readonly backgroundColor: string | null;
                readonly textSize: string | null;
                readonly textWeight: number | null;
              } | null;
              readonly height: string | null;
              readonly selected: {
                readonly backgroundColor: string | null;
                readonly textSize: string | null;
                readonly textWeight: number | null;
              } | null;
              readonly width: string | null;
            } | null;
            readonly tabs: {
              readonly active: {
                readonly backgroundColor: string | null;
                readonly borderBottomColor: string | null;
                readonly textColor: string | null;
              } | null;
              readonly backgroundColor: string | null;
              readonly borderBottomColor: string | null;
              readonly fontSize: string | null;
              readonly hover: {
                readonly backgroundColor: string | null;
              } | null;
              readonly padding: string | null;
              readonly textColor: string | null;
            } | null;
            readonly textButton: {
              readonly destructive: {
                readonly active: {
                  readonly color: string | null;
                } | null;
                readonly default: {
                  readonly color: string | null;
                } | null;
                readonly hover: {
                  readonly color: string | null;
                } | null;
              } | null;
              readonly primary: {
                readonly active: {
                  readonly color: string | null;
                } | null;
                readonly default: {
                  readonly color: string | null;
                } | null;
                readonly hover: {
                  readonly color: string | null;
                } | null;
              } | null;
            } | null;
          } | null;
          readonly disabledOpacity: string | null;
          readonly font: string | null;
          readonly highlighted: string | null;
          readonly primary: string | null;
          readonly primary_dark: string | null;
          readonly primary_light: string | null;
          readonly secondary: string | null;
          readonly secondary_alt: string | null;
          readonly secondary_dark: string | null;
        } | null;
        readonly button: {
          readonly color: string | null;
          readonly textColor: string | null;
        } | null;
        readonly font: {
          readonly black: number | null;
          readonly bold: number | null;
          readonly extra_bold: number | null;
          readonly medium: number | null;
          readonly regular: number | null;
          readonly semi_bold: number | null;
        } | null;
        readonly input: {
          readonly color: string | null;
          readonly textSize: string | null;
        } | null;
        readonly loadingType: string | null;
        readonly size: {
          readonly container: string | null;
        } | null;
        readonly skeleton: {
          readonly backgroundColor: string | null;
          readonly foregroundColor: string | null;
        } | null;
        readonly text: {
          readonly boldWeight: number | null;
        } | null;
      } | null;
      readonly isExternalLinksHidden: boolean | null;
      readonly isHelpWidgetHidden: boolean | null;
      readonly isSidebarHidden: boolean | null;
      readonly isToolbarHidden: boolean | null;
    };
  } | null;
};
export type customThemeProviderQueryCustomStyleQuery = {
  response: customThemeProviderQueryCustomStyleQuery$data;
  variables: customThemeProviderQueryCustomStyleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundColor",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textColor",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fontSize",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "padding",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "borderBottomColor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "borderRadius",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v9 = [
  (v8/*:: as any*/),
  (v6/*:: as any*/),
  (v5/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v12 = [
  (v8/*:: as any*/),
  (v10/*:: as any*/),
  (v11/*:: as any*/)
],
v13 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleHelp",
    "kind": "LinkedField",
    "name": "default",
    "plural": false,
    "selections": (v12/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleHelp",
    "kind": "LinkedField",
    "name": "hover",
    "plural": false,
    "selections": (v12/*:: as any*/),
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fontWeight",
  "storageKey": null
},
v15 = [
  (v0/*:: as any*/),
  (v8/*:: as any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textWeight",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textSize",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "background",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "border",
  "storageKey": null
},
v20 = [
  (v18/*:: as any*/),
  (v19/*:: as any*/)
],
v21 = [
  (v18/*:: as any*/),
  (v19/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "inputColor",
    "storageKey": null
  }
],
v22 = [
  (v7/*:: as any*/),
  (v10/*:: as any*/),
  (v11/*:: as any*/),
  (v16/*:: as any*/),
  (v17/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleUnselected",
    "kind": "LinkedField",
    "name": "unselected",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomStyleUnselectedActive",
        "kind": "LinkedField",
        "name": "active",
        "plural": false,
        "selections": (v20/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomStyleUnselectedActive",
        "kind": "LinkedField",
        "name": "disabled",
        "plural": false,
        "selections": (v20/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleSelected",
    "kind": "LinkedField",
    "name": "selected",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomStyleSelectedActive",
        "kind": "LinkedField",
        "name": "active",
        "plural": false,
        "selections": (v21/*:: as any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomStyleSelectedActive",
        "kind": "LinkedField",
        "name": "disabled",
        "plural": false,
        "selections": (v21/*:: as any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v23 = [
  (v0/*:: as any*/),
  (v16/*:: as any*/),
  (v17/*:: as any*/)
],
v24 = [
  (v0/*:: as any*/),
  (v1/*:: as any*/)
],
v25 = [
  (v19/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleGhostClass",
    "kind": "LinkedField",
    "name": "default",
    "plural": false,
    "selections": (v24/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleGhostClass",
    "kind": "LinkedField",
    "name": "hover",
    "plural": false,
    "selections": (v24/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleGhostClass",
    "kind": "LinkedField",
    "name": "active",
    "plural": false,
    "selections": (v24/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStyleDisabled",
    "kind": "LinkedField",
    "name": "disabled",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "opacity",
        "storageKey": null
      },
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v19/*:: as any*/)
    ],
    "storageKey": null
  }
],
v26 = [
  (v8/*:: as any*/)
],
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStylePurpleActive",
    "kind": "LinkedField",
    "name": "default",
    "plural": false,
    "selections": (v26/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStylePurpleActive",
    "kind": "LinkedField",
    "name": "hover",
    "plural": false,
    "selections": (v26/*:: as any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomStylePurpleActive",
    "kind": "LinkedField",
    "name": "active",
    "plural": false,
    "selections": (v26/*:: as any*/),
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "CustomStyleObject",
  "kind": "LinkedField",
  "name": "customStyle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isToolbarHidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSidebarHidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isHelpWidgetHidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternalLinksHidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomStyleBackofficeCustomTheme",
      "kind": "LinkedField",
      "name": "backofficeCustomTheme",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomStyleApp",
          "kind": "LinkedField",
          "name": "app",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "font",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primary_dark",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "primary_light",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondary_alt",
              "storageKey": null
            },
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundColorBase",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "secondary_dark",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundColor_dark",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "highlighted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "backgroundToolbar",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "disabledOpacity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CustomStyleComponent",
              "kind": "LinkedField",
              "name": "component",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleTabs",
                  "kind": "LinkedField",
                  "name": "tabs",
                  "plural": false,
                  "selections": [
                    (v1/*:: as any*/),
                    (v2/*:: as any*/),
                    (v0/*:: as any*/),
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleHover",
                      "kind": "LinkedField",
                      "name": "hover",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleTabsActive",
                      "kind": "LinkedField",
                      "name": "active",
                      "plural": false,
                      "selections": [
                        (v1/*:: as any*/),
                        (v4/*:: as any*/),
                        (v0/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleAccordion",
                  "kind": "LinkedField",
                  "name": "accordion",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "titleColor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lineColor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "textItemColor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStylePageTitle",
                  "kind": "LinkedField",
                  "name": "pageTitle",
                  "plural": false,
                  "selections": [
                    (v5/*:: as any*/),
                    (v1/*:: as any*/),
                    (v6/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleCard",
                  "kind": "LinkedField",
                  "name": "card",
                  "plural": false,
                  "selections": [
                    (v7/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleTitleClass",
                      "kind": "LinkedField",
                      "name": "title",
                      "plural": false,
                      "selections": (v9/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleTitleClass",
                      "kind": "LinkedField",
                      "name": "text",
                      "plural": false,
                      "selections": (v9/*:: as any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleLink",
                  "kind": "LinkedField",
                  "name": "link",
                  "plural": false,
                  "selections": [
                    (v8/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "decoration",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleIcon",
                  "kind": "LinkedField",
                  "name": "icon",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleInfoClass",
                      "kind": "LinkedField",
                      "name": "button",
                      "plural": false,
                      "selections": (v13/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleInfoClass",
                      "kind": "LinkedField",
                      "name": "info",
                      "plural": false,
                      "selections": (v13/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleHelp",
                      "kind": "LinkedField",
                      "name": "help",
                      "plural": false,
                      "selections": (v12/*:: as any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleMessage",
                  "kind": "LinkedField",
                  "name": "message",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v3/*:: as any*/),
                    (v7/*:: as any*/),
                    (v14/*:: as any*/),
                    (v2/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleError",
                      "kind": "LinkedField",
                      "name": "warning",
                      "plural": false,
                      "selections": (v15/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleError",
                      "kind": "LinkedField",
                      "name": "error",
                      "plural": false,
                      "selections": (v15/*:: as any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleCheckbox",
                  "kind": "LinkedField",
                  "name": "checkbox",
                  "plural": false,
                  "selections": (v22/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleSwitch",
                  "kind": "LinkedField",
                  "name": "switch",
                  "plural": false,
                  "selections": [
                    (v7/*:: as any*/),
                    (v10/*:: as any*/),
                    (v11/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleDefault",
                      "kind": "LinkedField",
                      "name": "default",
                      "plural": false,
                      "selections": (v23/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleDefault",
                      "kind": "LinkedField",
                      "name": "selected",
                      "plural": false,
                      "selections": (v23/*:: as any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleCheckbox",
                  "kind": "LinkedField",
                  "name": "radio",
                  "plural": false,
                  "selections": (v22/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleComponentButton",
                  "kind": "LinkedField",
                  "name": "button",
                  "plural": false,
                  "selections": [
                    (v7/*:: as any*/),
                    (v2/*:: as any*/),
                    (v14/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleBasic",
                      "kind": "LinkedField",
                      "name": "primary",
                      "plural": false,
                      "selections": (v25/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleBasic",
                      "kind": "LinkedField",
                      "name": "basic",
                      "plural": false,
                      "selections": (v25/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleBasic",
                      "kind": "LinkedField",
                      "name": "destructive",
                      "plural": false,
                      "selections": (v25/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleDisabled",
                      "kind": "LinkedField",
                      "name": "disabled",
                      "plural": false,
                      "selections": [
                        (v19/*:: as any*/),
                        (v0/*:: as any*/),
                        (v1/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStyleTextButton",
                  "kind": "LinkedField",
                  "name": "textButton",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleDestructive",
                      "kind": "LinkedField",
                      "name": "primary",
                      "plural": false,
                      "selections": (v27/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStyleDestructive",
                      "kind": "LinkedField",
                      "name": "destructive",
                      "plural": false,
                      "selections": (v27/*:: as any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CustomStylePageBlocksContainer",
                  "kind": "LinkedField",
                  "name": "pageBlocksContainer",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CustomStylePageBlock",
                      "kind": "LinkedField",
                      "name": "pageBlock",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        (v19/*:: as any*/),
                        (v7/*:: as any*/),
                        (v3/*:: as any*/),
                        (v11/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CustomStylePageBlockLearnMoreClass",
                          "kind": "LinkedField",
                          "name": "pageBlockTitle",
                          "plural": false,
                          "selections": [
                            (v8/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "gap",
                              "storageKey": null
                            },
                            (v2/*:: as any*/),
                            (v14/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CustomStylePageBlockDescription",
                          "kind": "LinkedField",
                          "name": "pageBlockDescription",
                          "plural": false,
                          "selections": [
                            (v2/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CustomStylePageBlockButton",
                          "kind": "LinkedField",
                          "name": "pageBlockButton",
                          "plural": false,
                          "selections": [
                            (v3/*:: as any*/),
                            (v2/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CustomStylePageBlockLearnMoreClass",
                          "kind": "LinkedField",
                          "name": "pageBlockLearnMore",
                          "plural": false,
                          "selections": [
                            (v8/*:: as any*/),
                            (v2/*:: as any*/),
                            (v14/*:: as any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomStyleInput",
          "kind": "LinkedField",
          "name": "input",
          "plural": false,
          "selections": [
            (v17/*:: as any*/),
            (v8/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomStyleBackofficeCustomThemeText",
          "kind": "LinkedField",
          "name": "text",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boldWeight",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomStyleBackofficeCustomThemeButton",
          "kind": "LinkedField",
          "name": "button",
          "plural": false,
          "selections": [
            (v8/*:: as any*/),
            (v1/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomStyleSkeleton",
          "kind": "LinkedField",
          "name": "skeleton",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "foregroundColor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomStyleSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "container",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CustomStyleFont",
          "kind": "LinkedField",
          "name": "font",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regular",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "medium",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "semi_bold",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bold",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "extra_bold",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "black",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "loadingType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "customThemeProviderQueryCustomStyleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketplaceCustomStyle",
        "kind": "LinkedField",
        "name": "marketplaceCustomStyleForSeller",
        "plural": false,
        "selections": [
          (v28/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "customThemeProviderQueryCustomStyleQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MarketplaceCustomStyle",
        "kind": "LinkedField",
        "name": "marketplaceCustomStyleForSeller",
        "plural": false,
        "selections": [
          (v28/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b3a2a73d798693a8df75f77d5389c0c8",
    "id": null,
    "metadata": {},
    "name": "customThemeProviderQueryCustomStyleQuery",
    "operationKind": "query",
    "text": "query customThemeProviderQueryCustomStyleQuery {\n  marketplaceCustomStyleForSeller {\n    customStyle {\n      isToolbarHidden\n      isSidebarHidden\n      isHelpWidgetHidden\n      isExternalLinksHidden\n      backofficeCustomTheme {\n        app {\n          font\n          primary\n          primary_dark\n          primary_light\n          secondary\n          secondary_alt\n          backgroundColor\n          backgroundColorBase\n          secondary_dark\n          backgroundColor_dark\n          highlighted\n          backgroundToolbar\n          disabledOpacity\n          component {\n            tabs {\n              textColor\n              fontSize\n              backgroundColor\n              padding\n              borderBottomColor\n              hover {\n                backgroundColor\n              }\n              active {\n                textColor\n                borderBottomColor\n                backgroundColor\n              }\n            }\n            accordion {\n              titleColor\n              lineColor\n              textItemColor\n            }\n            pageTitle {\n              size\n              textColor\n              weight\n            }\n            card {\n              borderRadius\n              title {\n                color\n                weight\n                size\n              }\n              text {\n                color\n                weight\n                size\n              }\n            }\n            link {\n              color\n              decoration\n            }\n            icon {\n              button {\n                default {\n                  color\n                  width\n                  height\n                }\n                hover {\n                  color\n                  width\n                  height\n                }\n              }\n              info {\n                default {\n                  color\n                  width\n                  height\n                }\n                hover {\n                  color\n                  width\n                  height\n                }\n              }\n              help {\n                color\n                width\n                height\n              }\n            }\n            message {\n              backgroundColor\n              padding\n              borderRadius\n              fontWeight\n              fontSize\n              warning {\n                backgroundColor\n                color\n              }\n              error {\n                backgroundColor\n                color\n              }\n            }\n            checkbox {\n              borderRadius\n              width\n              height\n              textWeight\n              textSize\n              unselected {\n                active {\n                  background\n                  border\n                }\n                disabled {\n                  background\n                  border\n                }\n              }\n              selected {\n                active {\n                  background\n                  border\n                  inputColor\n                }\n                disabled {\n                  background\n                  border\n                  inputColor\n                }\n              }\n            }\n            switch {\n              borderRadius\n              width\n              height\n              default {\n                backgroundColor\n                textWeight\n                textSize\n              }\n              selected {\n                backgroundColor\n                textWeight\n                textSize\n              }\n            }\n            radio {\n              borderRadius\n              width\n              height\n              textWeight\n              textSize\n              unselected {\n                active {\n                  background\n                  border\n                }\n                disabled {\n                  background\n                  border\n                }\n              }\n              selected {\n                active {\n                  background\n                  border\n                  inputColor\n                }\n                disabled {\n                  background\n                  border\n                  inputColor\n                }\n              }\n            }\n            button {\n              borderRadius\n              fontSize\n              fontWeight\n              primary {\n                border\n                default {\n                  backgroundColor\n                  textColor\n                }\n                hover {\n                  backgroundColor\n                  textColor\n                }\n                active {\n                  backgroundColor\n                  textColor\n                }\n                disabled {\n                  opacity\n                  backgroundColor\n                  textColor\n                  border\n                }\n              }\n              basic {\n                border\n                default {\n                  backgroundColor\n                  textColor\n                }\n                hover {\n                  backgroundColor\n                  textColor\n                }\n                active {\n                  backgroundColor\n                  textColor\n                }\n                disabled {\n                  opacity\n                  backgroundColor\n                  textColor\n                  border\n                }\n              }\n              destructive {\n                border\n                default {\n                  backgroundColor\n                  textColor\n                }\n                hover {\n                  backgroundColor\n                  textColor\n                }\n                active {\n                  backgroundColor\n                  textColor\n                }\n                disabled {\n                  opacity\n                  backgroundColor\n                  textColor\n                  border\n                }\n              }\n              disabled {\n                border\n                backgroundColor\n                textColor\n              }\n            }\n            textButton {\n              primary {\n                default {\n                  color\n                }\n                hover {\n                  color\n                }\n                active {\n                  color\n                }\n              }\n              destructive {\n                default {\n                  color\n                }\n                hover {\n                  color\n                }\n                active {\n                  color\n                }\n              }\n            }\n            pageBlocksContainer {\n              pageBlock {\n                backgroundColor\n                border\n                borderRadius\n                padding\n                height\n                pageBlockTitle {\n                  color\n                  gap\n                  fontSize\n                  fontWeight\n                }\n                pageBlockDescription {\n                  fontSize\n                }\n                pageBlockButton {\n                  padding\n                  fontSize\n                }\n                pageBlockLearnMore {\n                  color\n                  fontSize\n                  fontWeight\n                }\n              }\n            }\n          }\n        }\n        input {\n          textSize\n          color\n        }\n        text {\n          boldWeight\n        }\n        button {\n          color\n          textColor\n        }\n        skeleton {\n          backgroundColor\n          foregroundColor\n        }\n        size {\n          container\n        }\n        font {\n          regular\n          medium\n          semi_bold\n          bold\n          extra_bold\n          black\n        }\n        loadingType\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3b1299c349afbf45e5987731d1b3336c";

export default node;
